import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'PNS'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const PNSlistPeriod = 'Kepegawaian/PengangkatanPNS/listPeriod/'
export const PNSdetailPeriod = 'Kepegawaian/PengangkatanPNS/detailPeriod/'

export const PNSlistCPNS = 'Kepegawaian/PengangkatanPNS/listCPNS/'
export const PNSdetailCPNS = 'Kepegawaian/PengangkatanPNS/detailCPNS/'
export const PNSdetailPNS = 'Kepegawaian/PengangkatanPNS/detailPNS/'
export const PNSprocessPNS = 'Kepegawaian/PengangkatanPNS/processPNS/'
export const PNSuploadSKPNS = 'Kepegawaian/PengangkatanPNS/uploadSKPNS/'

export const PNSDownloadDraftSK = 'Kepegawaian/PengangkatanPNS/downloadDraftSK/'

export const masterRank = 'Kepegawaian/Rank/list/'
export const masterDocumentType = 'Kepegawaian/DocumentType/list/'
export const masterSignatoryOfficial = 'Kepegawaian/SignatoryOfficial/list/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}